// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__qW-bQ","title":"ClientInsurance_title__2SPKL","itemText":"ClientInsurance_itemText__uasqo"};